module.exports = __webpack_public_path__ + "assets/webgl/Assets_3_base_color.jpg.etc.b27d3057.ktx";